import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    bottom: '-0.5rem',
    right: '1.5rem'
  },

  anchor: {
    position: 'relative',
    right: '2rem',
    bottom: '7.75rem'
  },

  addPerson: {
    borderColor: '#FF595E',
    color: '#FF595E'
  },

  addCategory: {
    borderColor: '#47D1F5',
    color: '#47D1F5'
  },

  addTask: {
    borderColor: '#F48E16',
    color: '#F48E16'
  },

  addArticle: {
    borderColor: '#8E16F4',
    color: '#8E16F4'
  }
}))

export default useStyles
